module.exports = __webpack_public_path__ + "static/media/chorthippus_apricarius_003_APA.38608a97.png";